import * as yup from 'yup';

export default yup.object({
    topic_name: yup.string().trim().required('Name is a required field'),
    topic_summary: yup.string().trim().required('Summary is a required field'),
    topic_facts: yup
        .array()
        .of(yup.string())
        .min(1, 'At least one fact is required'),
    confidence: yup.number().required('Confidence is a required field'),
    source: yup.string().trim(),
    labels: yup.array().of(yup.string())
});
